
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import { getExchangeAccount, exchangeCash } from "../../common/js/api.js";
import { getCookie, setCookie, removeCookie } from "../../common/js/utils";
import { wxORzfb } from "../../common/js/config"
import router from "@/router/index.js";

export default {
directives: {
TransferDom
},
components: {
Box,
XButton,
XInput,
Group,
TransferDom,
XDialog,
Popup
},
data() {
return {
lessTime: 0,
showBeanCash: false,
showOouyanHaoWu: false,
view: {
codeText: "获取验证码",
disabled: false,
sendCode: false
},
entity: {
mobile: "",
code: ""
},
userId: "",
beans: 0,
total: 0
};
},
methods: {
showBeanCashFn() {
this.showBeanCash = true
},
onCancel () {
this.showBeanCash = false
},
showOouyanHaoWuFn () {
this.showOouyanHaoWu = true
},
onSubmit(val) {
let self = this;
if (!this.entity.amount) {
self.$vux.toast.text("请输入鸥豆数量");
return;
}
if (this.entity.amount <= 0) {
self.$vux.toast.text("鸥豆数量需要大于0");
return;
}
if (this.entity.amount > self.beans) {
self.$vux.toast.text("鸥豆数量不能大于可提现数量");
return;
}
this.$vux.confirm.show({

title: "提醒您",
content: "确定要提现吗？",
onCancel() {},
onConfirm() {
self.$vux.loading.show({
text: "正在提现..."
});
let url = ""
if (wxORzfb == "wx") {
url = '/api/app/goldRecord/applyExchangeCash/' + self.entity.amount
} else if(wxORzfb == "zfb") {
url = '/api/app/goldRecord/applyExchangeCash/' + self.entity.amount + "?channel=alipay"
}
exchangeCash({
url: url,
data: {
amount: self.entity.amount
}
}).then(function(data) {
self.$vux.loading.hide();
router.replace({
path: "/success",
query: { message: "申请提现成功，审核之后将到账" }
});
});
}
});
}
},
created() {
let self = this;
this.userId = this.$route.query.userId;
getExchangeAccount({}).then(function(data) {
self.beans = data.Content;
self.total = data.Message;
});
}
};



// WEBPACK FOOTER //
// ./src/components/usercenter/beanCash.vue